import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/jnit logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid" style={{justifyContent: 'start'}}>
            <div className="footer-section" style={{textAlign: 'start'}}>
              <div className="footer-header">
                <div className="logo-container">
                  <img src={logo} alt="JN IT Logo Front" className="footer-logo front" />
                  <img src={logo} alt="JN IT Logo Back" className="footer-logo back" />
                </div>
                <h3><Link to="/">JN IT Digital Solutions</Link></h3>
              </div>
              <p>Leading digital marketing agency transforming businesses through innovative strategies and cutting-edge technology.</p>
              <p className="footer-tagline">Growing a Business Online Isn’t Easy... But That’s Why We’re Here.</p>
            </div>
            
            <div className="footer-section">
              <h4>Office Address</h4>
              <p>
                JN IT Digital Solutions<br />
                Madhurawada, Visakhapatnam<br />
                Andhra Pradesh, India 530048
              </p>
            </div>
            
            <div className="footer-section">
              <h4>Contact Info</h4>
              <p>Phone: +91-7794087189</p>
              <p>Email: jnitdigitalmarketing@gmail.com</p>
            </div>
            
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><Link to="/seo-services">SEO Services</Link></li>
                <li><a href="#services">Social Media Marketing</a></li>
                <li><a href="#services">Search Engine Marketing</a></li>
                <li><a href="#services">App Development</a></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2025 JN IT Digital Solutions. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
